// extracted by mini-css-extract-plugin
export default {"content":"ConfirmDialog_content__Ojk-g","warningIcon":"ConfirmDialog_warningIcon__0w8Ym","message":"ConfirmDialog_message__oux8S"};